import { Button } from '@rockalingua/ui';

export default Button;
